import { Component } from 'preact';

export default class Modal extends Component {
	handleBackdropClick = (event) => {
		if (event.target !== event.currentTarget) {
			return;
		}
		this.props.onHide();
	};

	handleEscapePressed = (event) => {
		if (event.keyCode === 27) {
			this.props.onHide();
		}
	};

	componentDidMount(){
		document.addEventListener('keydown', this.handleEscapePressed, false);
	}

	/**
	 * Add or remove modal-open body class
	 */
	componentWillReceiveProps(nextProps, nextContext) {
		if (!window) {
			return;
		}

		const { show } = nextProps;

		if (show) {
			document.body.classList.add('modal-open');
		}
		else {
			document.body.classList.remove('modal-open');
		}
	}

	componentWillUnmount(){
		document.removeEventListener('keydown', this.handleEscapePressed, false);
	}

	render({ show, onHide, children, footer, title, modalClasses }) {
		const showClass = show ? 'show' : '';
		return (
			<div>
				<div className={`modal fade ${showClass}`} tabindex="-1" role="dialog" aria-hidden="true" onClick={this.handleBackdropClick}>
					<div className={`modal-dialog ${modalClasses}`} role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="modal-dialog">{title ? title : ''}</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onHide}>
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body">
								{children}
							</div>
							<div className="modal-footer">
								{footer}
							</div>
						</div>
					</div>
				</div>
				<div className={`${show ? 'modal-backdrop' : ''} fade ${showClass}`} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/ui/Modal.js